import axios from 'axios'

const service = axios.create({
    timeout: 50000, // 请求超时
})


service.interceptors.request.use(
    config => {
        return config
    },
    error => {
      Promise.reject(error)
    }
)
service.interceptors.response.use(
    (res) => {
        return res.data
    },
    (err) => {
        console.log(err);
    }
)
export default service;